"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5662],{

/***/ 755662:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "rB": function() { return /* binding */ AccordionListItem; }
/* harmony export */ });
/* unused harmony exports AccordionButton, AccordionIcon, AccordionPanel */
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(382526);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(141817);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(932165);
/* harmony import */ var core_js_modules_es_symbol_to_primitive_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(696649);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(57327);
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(489554);
/* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(491038);
/* harmony import */ var core_js_modules_es_array_index_of_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(682772);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(66992);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(747042);
/* harmony import */ var core_js_modules_es_date_to_primitive_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(396078);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(968309);
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(209653);
/* harmony import */ var core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(319601);
/* harmony import */ var core_js_modules_es_object_define_properties_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(833321);
/* harmony import */ var core_js_modules_es_object_define_property_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(369070);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(438880);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(749337);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(447941);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(241539);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(974916);
/* harmony import */ var core_js_modules_es_regexp_test_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(477601);
/* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(339714);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(978783);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(454747);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(333948);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(667294);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(624614);
/* harmony import */ var _index_mjs__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(573298);
/* harmony import */ var _index_mjs__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(4796);
/* harmony import */ var _index_mjs__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(726029);
/* harmony import */ var _index_mjs__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(593298);
/* harmony import */ var _index_mjs__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(208013);
/* harmony import */ var _hooks_useObservabilitySafe_mjs__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(298352);
/* harmony import */ var _system_utils_index_mjs__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(848189);
/* harmony import */ var _Icon_Icon_mjs__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(549154);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }


























var _excluded = ["analyticsName", "title", "children", "startExpanded", "justifyContent", "noPadding", "wrapText", "expandOnFocus", "panelId", "onOpen", "onToggle", "variant", "onMouseEnter", "maxHeight", "hasUnderline", "hasBorder", "paddingInline"],
  _excluded2 = ["isOpen", "panelId"],
  _excluded3 = ["panelId", "isOpen", "maxHeight", "onContentFocus"];
function cov_22w7c5ye2p() {
  var path = "/__w/code/code/js/packages/bricks/src/core/List/AccordionListItem.tsx";
  var hash = "27631e4619d4d9529b7ac93d1343d7964c3ee85b";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/List/AccordionListItem.tsx",
    statementMap: {
      "0": {
        start: {
          line: 74,
          column: 33
        },
        end: {
          line: 165,
          column: 1
        }
      },
      "1": {
        start: {
          line: 103,
          column: 32
        },
        end: {
          line: 103,
          column: 64
        }
      },
      "2": {
        start: {
          line: 104,
          column: 34
        },
        end: {
          line: 104,
          column: 56
        }
      },
      "3": {
        start: {
          line: 105,
          column: 19
        },
        end: {
          line: 116,
          column: 6
        }
      },
      "4": {
        start: {
          line: 122,
          column: 24
        },
        end: {
          line: 135,
          column: 58
        }
      },
      "5": {
        start: {
          line: 123,
          column: 6
        },
        end: {
          line: 125,
          column: 7
        }
      },
      "6": {
        start: {
          line: 124,
          column: 8
        },
        end: {
          line: 124,
          column: 17
        }
      },
      "7": {
        start: {
          line: 126,
          column: 6
        },
        end: {
          line: 126,
          column: 29
        }
      },
      "8": {
        start: {
          line: 127,
          column: 6
        },
        end: {
          line: 132,
          column: 7
        }
      },
      "9": {
        start: {
          line: 128,
          column: 8
        },
        end: {
          line: 131,
          column: 11
        }
      },
      "10": {
        start: {
          line: 133,
          column: 6
        },
        end: {
          line: 133,
          column: 45
        }
      },
      "11": {
        start: {
          line: 133,
          column: 32
        },
        end: {
          line: 133,
          column: 43
        }
      },
      "12": {
        start: {
          line: 137,
          column: 4
        },
        end: {
          line: 163,
          column: 6
        }
      },
      "13": {
        start: {
          line: 153,
          column: 12
        },
        end: {
          line: 153,
          column: 56
        }
      },
      "14": {
        start: {
          line: 175,
          column: 63
        },
        end: {
          line: 194,
          column: 1
        }
      },
      "15": {
        start: {
          line: 176,
          column: 17
        },
        end: {
          line: 176,
          column: 64
        }
      },
      "16": {
        start: {
          line: 177,
          column: 2
        },
        end: {
          line: 193,
          column: 4
        }
      },
      "17": {
        start: {
          line: 197,
          column: 71
        },
        end: {
          line: 205,
          column: 1
        }
      },
      "18": {
        start: {
          line: 198,
          column: 17
        },
        end: {
          line: 198,
          column: 64
        }
      },
      "19": {
        start: {
          line: 200,
          column: 2
        },
        end: {
          line: 204,
          column: 4
        }
      },
      "20": {
        start: {
          line: 210,
          column: 4
        },
        end: {
          line: 228,
          column: 1
        }
      },
      "21": {
        start: {
          line: 211,
          column: 17
        },
        end: {
          line: 214,
          column: 4
        }
      },
      "22": {
        start: {
          line: 215,
          column: 2
        },
        end: {
          line: 227,
          column: 4
        }
      },
      "23": {
        start: {
          line: 224,
          column: 21
        },
        end: {
          line: 224,
          column: 61
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 75,
            column: 2
          },
          end: {
            line: 75,
            column: 3
          }
        },
        loc: {
          start: {
            line: 102,
            column: 7
          },
          end: {
            line: 164,
            column: 3
          }
        },
        line: 102
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 122,
            column: 36
          },
          end: {
            line: 122,
            column: 37
          }
        },
        loc: {
          start: {
            line: 122,
            column: 42
          },
          end: {
            line: 135,
            column: 5
          }
        },
        line: 122
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 133,
            column: 16
          },
          end: {
            line: 133,
            column: 17
          }
        },
        loc: {
          start: {
            line: 133,
            column: 32
          },
          end: {
            line: 133,
            column: 43
          }
        },
        line: 133
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 152,
            column: 26
          },
          end: {
            line: 152,
            column: 27
          }
        },
        loc: {
          start: {
            line: 152,
            column: 47
          },
          end: {
            line: 154,
            column: 11
          }
        },
        line: 152
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 175,
            column: 63
          },
          end: {
            line: 175,
            column: 64
          }
        },
        loc: {
          start: {
            line: 175,
            column: 98
          },
          end: {
            line: 194,
            column: 1
          }
        },
        line: 175
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 197,
            column: 71
          },
          end: {
            line: 197,
            column: 72
          }
        },
        loc: {
          start: {
            line: 197,
            column: 82
          },
          end: {
            line: 205,
            column: 1
          }
        },
        line: 197
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 210,
            column: 4
          },
          end: {
            line: 210,
            column: 5
          }
        },
        loc: {
          start: {
            line: 210,
            column: 66
          },
          end: {
            line: 228,
            column: 1
          }
        },
        line: 210
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 224,
            column: 15
          },
          end: {
            line: 224,
            column: 16
          }
        },
        loc: {
          start: {
            line: 224,
            column: 21
          },
          end: {
            line: 224,
            column: 61
          }
        },
        line: 224
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 80,
            column: 6
          },
          end: {
            line: 80,
            column: 27
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 80,
            column: 22
          },
          end: {
            line: 80,
            column: 27
          }
        }],
        line: 80
      },
      "1": {
        loc: {
          start: {
            line: 82,
            column: 6
          },
          end: {
            line: 82,
            column: 23
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 82,
            column: 18
          },
          end: {
            line: 82,
            column: 23
          }
        }],
        line: 82
      },
      "2": {
        loc: {
          start: {
            line: 83,
            column: 6
          },
          end: {
            line: 83,
            column: 21
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 83,
            column: 17
          },
          end: {
            line: 83,
            column: 21
          }
        }],
        line: 83
      },
      "3": {
        loc: {
          start: {
            line: 84,
            column: 6
          },
          end: {
            line: 84,
            column: 27
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 84,
            column: 22
          },
          end: {
            line: 84,
            column: 27
          }
        }],
        line: 84
      },
      "4": {
        loc: {
          start: {
            line: 107,
            column: 15
          },
          end: {
            line: 107,
            column: 32
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 107,
            column: 27
          },
          end: {
            line: 107,
            column: 28
          }
        }, {
          start: {
            line: 107,
            column: 31
          },
          end: {
            line: 107,
            column: 32
          }
        }],
        line: 107
      },
      "5": {
        loc: {
          start: {
            line: 111,
            column: 18
          },
          end: {
            line: 111,
            column: 48
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 111,
            column: 29
          },
          end: {
            line: 111,
            column: 37
          }
        }, {
          start: {
            line: 111,
            column: 40
          },
          end: {
            line: 111,
            column: 48
          }
        }],
        line: 111
      },
      "6": {
        loc: {
          start: {
            line: 123,
            column: 6
          },
          end: {
            line: 125,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 123,
            column: 6
          },
          end: {
            line: 125,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 123
      },
      "7": {
        loc: {
          start: {
            line: 123,
            column: 10
          },
          end: {
            line: 123,
            column: 27
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 123,
            column: 10
          },
          end: {
            line: 123,
            column: 16
          }
        }, {
          start: {
            line: 123,
            column: 20
          },
          end: {
            line: 123,
            column: 27
          }
        }],
        line: 123
      },
      "8": {
        loc: {
          start: {
            line: 126,
            column: 6
          },
          end: {
            line: 126,
            column: 28
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 126,
            column: 6
          },
          end: {
            line: 126,
            column: 14
          }
        }, {
          start: {
            line: 126,
            column: 18
          },
          end: {
            line: 126,
            column: 28
          }
        }],
        line: 126
      },
      "9": {
        loc: {
          start: {
            line: 127,
            column: 6
          },
          end: {
            line: 132,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 127,
            column: 6
          },
          end: {
            line: 132,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 127
      },
      "10": {
        loc: {
          start: {
            line: 145,
            column: 11
          },
          end: {
            line: 145,
            column: 88
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 145,
            column: 39
          },
          end: {
            line: 145,
            column: 80
          }
        }, {
          start: {
            line: 145,
            column: 83
          },
          end: {
            line: 145,
            column: 88
          }
        }],
        line: 145
      },
      "11": {
        loc: {
          start: {
            line: 153,
            column: 12
          },
          end: {
            line: 153,
            column: 55
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 153,
            column: 12
          },
          end: {
            line: 153,
            column: 25
          }
        }, {
          start: {
            line: 153,
            column: 29
          },
          end: {
            line: 153,
            column: 36
          }
        }, {
          start: {
            line: 153,
            column: 40
          },
          end: {
            line: 153,
            column: 55
          }
        }],
        line: 153
      },
      "12": {
        loc: {
          start: {
            line: 156,
            column: 11
          },
          end: {
            line: 160,
            column: 11
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 157,
            column: 12
          },
          end: {
            line: 157,
            column: 59
          }
        }, {
          start: {
            line: 159,
            column: 12
          },
          end: {
            line: 159,
            column: 20
          }
        }],
        line: 156
      },
      "13": {
        loc: {
          start: {
            line: 224,
            column: 21
          },
          end: {
            line: 224,
            column: 61
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 224,
            column: 21
          },
          end: {
            line: 224,
            column: 35
          }
        }, {
          start: {
            line: 224,
            column: 39
          },
          end: {
            line: 224,
            column: 61
          }
        }],
        line: 224
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0
    },
    b: {
      "0": [0],
      "1": [0],
      "2": [0],
      "3": [0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0, 0],
      "12": [0, 0],
      "13": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "27631e4619d4d9529b7ac93d1343d7964c3ee85b"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_22w7c5ye2p = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_22w7c5ye2p();
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }






/**
 * Accordion component that has the ability to open for additional info or close
 * for less info. This component is used by AccordionList which stacks several
 * Accordions together If you are in bundle sensitive application (example:
 * Cosmos) that uses Selective Spritesheet you must import - ChevronDown16 to
 * get the chevron to appear
 *
 * AccordionListItem should only be used as a child of the AccordionList
 * component
 *
 *
 * ###
 *
 * Using AccordionList in bundle-sensitive apps
 *
 * If you are using an `accordionList` in a bundle-sensitive app like Cosmos
 * take note that you might need to use `SelectiveSpritesheet` to load in the
 * `chevrondown16` sprite sheet so the sprite sheet appears - example below
 *
 * ```
 * import SelectiveSpritesheet from '@opendoor/bricks/core/Icon/SelectiveSpritesheet';
 *
 * function showNewFAQS() {
 *    return(
 *        <Box>
 *          <H2>New FAQ</H2>
 *          <SelectiveSpriteSheet icons={[ChevronDown16]} />
 *          <List variant="accordion">
 *          <AccordionListItem>FAQ #1</AccordionListItem>
 *          </List>
 *        </Box>
 *    )
 * }
 * ```
 */
var AccordionListItem = (cov_22w7c5ye2p().s[0]++, (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_27__/* .forwardRef */ .Gp)(function (_ref, ref) {
  var analyticsName = _ref.analyticsName,
    title = _ref.title,
    children = _ref.children,
    _ref$startExpanded = _ref.startExpanded,
    startExpanded = _ref$startExpanded === void 0 ? (cov_22w7c5ye2p().b[0][0]++, false) : _ref$startExpanded,
    justifyContent = _ref.justifyContent,
    _ref$noPadding = _ref.noPadding,
    noPadding = _ref$noPadding === void 0 ? (cov_22w7c5ye2p().b[1][0]++, false) : _ref$noPadding,
    _ref$wrapText = _ref.wrapText,
    wrapText = _ref$wrapText === void 0 ? (cov_22w7c5ye2p().b[2][0]++, true) : _ref$wrapText,
    _ref$expandOnFocus = _ref.expandOnFocus,
    expandOnFocus = _ref$expandOnFocus === void 0 ? (cov_22w7c5ye2p().b[3][0]++, false) : _ref$expandOnFocus,
    panelId = _ref.panelId,
    onOpen = _ref.onOpen,
    onToggle = _ref.onToggle,
    variant = _ref.variant,
    onMouseEnter = _ref.onMouseEnter,
    maxHeight = _ref.maxHeight,
    hasUnderline = _ref.hasUnderline,
    hasBorder = _ref.hasBorder,
    paddingInline = _ref.paddingInline,
    props = _objectWithoutProperties(_ref, _excluded);
  cov_22w7c5ye2p().f[0]++;
  var _ref2 = (cov_22w7c5ye2p().s[1]++, (0,react__WEBPACK_IMPORTED_MODULE_26__.useState)(startExpanded)),
    _ref3 = _slicedToArray(_ref2, 2),
    isOpen = _ref3[0],
    setIsOpen = _ref3[1];
  var _ref4 = (cov_22w7c5ye2p().s[2]++, (0,_hooks_useObservabilitySafe_mjs__WEBPACK_IMPORTED_MODULE_28__/* .useObservabilitySafe */ .r)()),
    trackJourneyEvent = _ref4.trackJourneyEvent;
  var styles = (cov_22w7c5ye2p().s[3]++, (0,_system_utils_index_mjs__WEBPACK_IMPORTED_MODULE_29__/* .useMultiStyleConfig */ .jC)('AccordionListItem', _objectSpread({
    variant: variant,
    padding: noPadding ? (cov_22w7c5ye2p().b[4][0]++, 0) : (cov_22w7c5ye2p().b[4][1]++, 7),
    paddingInline: paddingInline,
    justifyContent: justifyContent,
    isOpen: isOpen,
    whiteSpace: wrapText ? (cov_22w7c5ye2p().b[5][0]++, 'normal') : (cov_22w7c5ye2p().b[5][1]++, 'nowrap'),
    maxHeight: maxHeight,
    hasBorder: hasBorder,
    hasUnderline: hasUnderline
  }, props)));
  /**
   * Handles opening the accordion when button is clicked
   * Calls the onOpen callback (if provided) when we're opening the accordion
   * Calls the onToggle callback (if provided) when we're opening and closing the accordion
   */
  var handleClick = (cov_22w7c5ye2p().s[4]++, (0,react__WEBPACK_IMPORTED_MODULE_26__.useCallback)(function () {
    cov_22w7c5ye2p().f[1]++;
    cov_22w7c5ye2p().s[5]++;
    if ((cov_22w7c5ye2p().b[7][0]++, onOpen) && (cov_22w7c5ye2p().b[7][1]++, !isOpen)) {
      cov_22w7c5ye2p().b[6][0]++;
      cov_22w7c5ye2p().s[6]++;
      onOpen();
    } else {
      cov_22w7c5ye2p().b[6][1]++;
    }
    cov_22w7c5ye2p().s[7]++;
    (cov_22w7c5ye2p().b[8][0]++, onToggle) && (cov_22w7c5ye2p().b[8][1]++, onToggle());
    cov_22w7c5ye2p().s[8]++;
    if (analyticsName) {
      cov_22w7c5ye2p().b[9][0]++;
      cov_22w7c5ye2p().s[9]++;
      trackJourneyEvent('platform', 'accordionClickEvent', {
        targetName: analyticsName,
        accordionName: panelId
      });
    } else {
      cov_22w7c5ye2p().b[9][1]++;
    }
    cov_22w7c5ye2p().s[10]++;
    setIsOpen(function (prevIsOpen) {
      cov_22w7c5ye2p().f[2]++;
      cov_22w7c5ye2p().s[11]++;
      return !prevIsOpen;
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [onOpen, isOpen, onToggle, analyticsName, panelId]));
  cov_22w7c5ye2p().s[12]++;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_26__.createElement(_index_mjs__WEBPACK_IMPORTED_MODULE_30__/* .ListItem */ .H, {
    __css: styles.listItem,
    "data-testid": "accordion-list-item",
    ref: ref
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_26__.createElement(AccordionButton, {
    isOpen: isOpen,
    panelId: panelId,
    justifyContent: justifyContent,
    onClick: handleClick
  }, typeof title === 'string' ? (cov_22w7c5ye2p().b[10][0]++, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_26__.createElement(_index_mjs__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z, {
    __css: styles.title
  }, title)) : (cov_22w7c5ye2p().b[10][1]++, title), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_26__.createElement(AccordionIcon, {
    isOpen: isOpen,
    justifyContent: justifyContent
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_26__.createElement(AccordionPanel, {
    isOpen: isOpen,
    panelId: panelId,
    maxHeight: maxHeight,
    onContentFocus: function onContentFocus(isOpen) {
      cov_22w7c5ye2p().f[3]++;
      cov_22w7c5ye2p().s[13]++;
      (cov_22w7c5ye2p().b[11][0]++, expandOnFocus) && (cov_22w7c5ye2p().b[11][1]++, !isOpen) && (cov_22w7c5ye2p().b[11][2]++, setIsOpen(true));
    }
  }, typeof children === 'string' ? (cov_22w7c5ye2p().b[12][0]++, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_26__.createElement(_index_mjs__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z, {
    __css: styles.bodyText
  }, children)) : (cov_22w7c5ye2p().b[12][1]++, children)));
}));
/** Accordion button that handles if the accordion is open or close */
cov_22w7c5ye2p().s[14]++;
var AccordionButton = function AccordionButton(_ref5) {
  var isOpen = _ref5.isOpen,
    panelId = _ref5.panelId,
    props = _objectWithoutProperties(_ref5, _excluded2);
  cov_22w7c5ye2p().f[4]++;
  var styles = (cov_22w7c5ye2p().s[15]++, (0,_system_utils_index_mjs__WEBPACK_IMPORTED_MODULE_29__/* .useMultiStyleConfig */ .jC)('AccordionListItem', props));
  cov_22w7c5ye2p().s[16]++;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_26__.createElement(_index_mjs__WEBPACK_IMPORTED_MODULE_32__/* ["default"] */ .ZP, _extends({
    variant: "ghost",
    __css: styles.button,
    "data-testid": "".concat(panelId, "-accordion-button")
    // We already track accordion hover/click events so we do not need duplicative tracking through Button
    ,
    analyticsName: ""
    // Blank aria-label because the question should be descriptive enough
    ,
    "aria-label": null
    // accordion controls value is equal the ID of the tag that wraps the expanded content
    ,
    "aria-controls": panelId
    // set on an element to indicate if a control is expanded or collapsed
    // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Attributes/aria-expanded
    ,
    "aria-expanded": isOpen
  }, props));
};

/** Chevron icon used inside Accordion Button that users can click to open or close accordion */
cov_22w7c5ye2p().s[17]++;
var AccordionIcon = function AccordionIcon(props) {
  cov_22w7c5ye2p().f[5]++;
  var styles = (cov_22w7c5ye2p().s[18]++, (0,_system_utils_index_mjs__WEBPACK_IMPORTED_MODULE_29__/* .useMultiStyleConfig */ .jC)('AccordionListItem', props));
  cov_22w7c5ye2p().s[19]++;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_26__.createElement(_index_mjs__WEBPACK_IMPORTED_MODULE_33__/* ["default"] */ .Z, {
    __css: styles.iconContainer
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_26__.createElement(_Icon_Icon_mjs__WEBPACK_IMPORTED_MODULE_34__/* ["default"] */ .Z, {
    name: "chevron-down",
    color: "neutrals100",
    size: 16
  }));
};

/** TODO: Panel is visable when isOpen is true */
cov_22w7c5ye2p().s[20]++;
var AccordionPanel = function AccordionPanel(_ref6) {
  var panelId = _ref6.panelId,
    isOpen = _ref6.isOpen,
    maxHeight = _ref6.maxHeight,
    onContentFocus = _ref6.onContentFocus,
    props = _objectWithoutProperties(_ref6, _excluded3);
  cov_22w7c5ye2p().f[6]++;
  var styles = (cov_22w7c5ye2p().s[21]++, (0,_system_utils_index_mjs__WEBPACK_IMPORTED_MODULE_29__/* .useMultiStyleConfig */ .jC)('AccordionListItem', {
    isOpen: isOpen,
    maxHeight: maxHeight
  }));
  cov_22w7c5ye2p().s[22]++;
  return (
    /*#__PURE__*/
    // TODO(@core-experience-platform): Fix this a11y violation
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    react__WEBPACK_IMPORTED_MODULE_26__.createElement(_index_mjs__WEBPACK_IMPORTED_MODULE_35__/* ["default"] */ .Z, _extends({
      __css: styles.panel,
      "data-testid": "accordion-panel"
      // Hide from screen-readers while closed
      ,
      "aria-hidden": !isOpen,
      id: panelId,
      onFocus: function onFocus() {
        cov_22w7c5ye2p().f[7]++;
        cov_22w7c5ye2p().s[23]++;
        return (cov_22w7c5ye2p().b[13][0]++, onContentFocus) && (cov_22w7c5ye2p().b[13][1]++, onContentFocus(isOpen));
      }
    }, props))
  );
};

/***/ })

}]);